import React, {useContext, useEffect, useState} from "react";
import {Col, Container, Row} from "react-bootstrap";
import SwiftMessageSearchPanel from "./SwiftMessageSearchPanel";
import {ActionPanelContextProvider} from "../../../context/action";
import {SecurityContext} from "../../../context/security";
import {SwiftMessageContext} from "./context";


export default function SwiftPanel() {

    const {panelDisplayState,setPanelDisplayState} = useContext(SwiftMessageContext);
    const {resetFlagRight} = useContext(SecurityContext);

    useEffect(()=>{
        if(resetFlagRight.current){
            resetFlagRight.current = false;
            const newFilterState = {...panelDisplayState}
            newFilterState['currentPage'] = 'defaultlanding';
            setPanelDisplayState(newFilterState);
        }
    },[]);


    const currentComponent = function () {
        return <ActionPanelContextProvider><SwiftMessageSearchPanel/></ActionPanelContextProvider>
    }

    return(<>

        <Container fluid>
            <Row>
                <Col style={{padding:0}}>
                    {currentComponent()}
                </Col>
            </Row>
            <Row>
                <br/>
            </Row>
        </Container>
    </>);

}
